import { Card, CardContent } from '@/components/ui/card';
import { SectionHeading, EmptySection, Field, StatusBadge } from './shared';

interface Props {
  data: any[];
}

export default function EquipmentSection({ data }: Props) {
  return (
    <section>
      <SectionHeading id="section-equipment" title="Equipment" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="equipment entries" />
      ) : (
        <div className="mt-2 space-y-3">
          {data.map((row: any) => (
            <Card key={row.id}>
              <CardContent className="pt-4">
                <div className="mb-2 flex items-center gap-2">
                  <span className="text-sm font-medium">{row.equipment_name}</span>
                  <StatusBadge status={row.status} />
                </div>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                  <Field label="Type" value={row.equipment_type} />
                  <Field label="Asset ID" value={row.equipment_identifier} />
                  <Field
                    label="Hours Operated"
                    value={row.hours_operated != null ? `${row.hours_operated} hrs` : null}
                  />
                  <Field label="Operator / Crew" value={row.operator_crew} />
                  {row.notes && (
                    <div className="col-span-full">
                      <Field label="Notes" value={row.notes} />
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
